<template>
  <div class="compare-pano">
    <div class="pano-container">
      <div id="pano1" class="pano">
        <div class="page-title" v-if="title1">{{ title1 }}</div>
      </div>
      <div id="pano2" class="pano">
        <div class="page-title" v-if="title2">{{ title2 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as panoApi from '@/api/pano';

const isDev = process.env.NODE_ENV === 'development';

export default {
  components: {
  },
  data() {
    return {
      isLoad: false,
      currentActive: 1,
      lastView: [],
      hooks1: {
        ready(krpano) {
          window.krpano1 = krpano;
        },
        viewChange: this.viewChange,
        onmousedown: this.onmousedown,
      },
      hooks2: {
        ready(krpano) {
          window.krpano2 = krpano;
          // 同步成一样的脚步
          if (window.krpano1) {
            const newView = [
              krpano.get('view.hlookat'),
              krpano.get('view.vlookat'),
            ];
            this.lastView = newView;
            window.krpano1.call(`lookat(${newView.join(',')})`);
          }
        },
        viewChange: this.viewChange2,
        onmousedown: this.onmousedown2,
      },
    };
  },
  computed: {
    xml1() {
      let { hall_id1:hall_id = 0, hall_hotel_id1:hotel_id = 0 } = this.$route.query;
      if (isDev && !hotel_id && !hall_id) {
        hotel_id = 1172;
        hall_id = 5838;
      }
      return panoApi.xml({ hotel_id, hall_id, compare:1 });
    },
    xml2() {
      let { hall_id2:hall_id = 0, hall_hotel_id2:hotel_id = 0 } = this.$route.query;
      if (isDev && !hotel_id && !hall_id) {
        hotel_id = 1172;
        hall_id = 5838;
      }
      return panoApi.xml({ hotel_id, hall_id, compare:2 });
    },
    title1() {
      const { hall_name1:hall_name, hall_hotel_name1:hotel_name = 0 } = this.$route.query;
      return hotel_name + '-' + hall_name;
    },
    title2() {
      const { hall_name2:hall_name, hall_hotel_name2:hotel_name = 0 } = this.$route.query;
      return hotel_name + '-' + hall_name;
    },
  },
  watch: {
    xml2() {
      this.initPano();
    },
  },
  mounted() {
    this.initPano();
  },
  beforeUnmount() {
    window.krpano1 = null;
    window.krpano2 = null;
  },
  methods: {
    async initPano() {
      if (this.xml1 && this.xml2) {
        await Promise.all([
          initPano({ xml: this.xml1, target: 'pano1' }, this.hooks1),
          initPano({ xml: this.xml2, target: 'pano2' }, this.hooks2),
        ]);
        this.isLoad = true;
      }
    },
    viewChange() {
      // 没有加载返回
      if (!this.isLoad) return;
      const { krpano1, krpano2 } = window;
      const { lastView = [] } = this;
      // 当前没有按下返回
      if (this.currentActive !== 1) return;
      const newView = [
        krpano1.get('view.hlookat'),
        krpano1.get('view.vlookat'),
        krpano1.get('view.fov'),
      ];
      if (
        lastView[0] === newView[0] &&
        lastView[1] === newView[1] &&
        lastView[2] === newView[2]
      ) {
        return;
      }
      this.lastView = newView;
      krpano2.call(`lookat(${lastView.join(',')})`);
    },
    onmousedown() {
      this.currentActive = 1;
    },
    viewChange2() {
      // 没有加载返回
      if (!this.isLoad) return;
      // 当前没有按下返回
      if (this.currentActive !== 2) return;
      const { krpano1, krpano2 } = window;
      const { lastView = [] } = this;
      const newView = [
        krpano2.get('view.hlookat'),
        krpano2.get('view.vlookat'),
        krpano2.get('view.fov'),
      ];
      if (
        lastView[0] === newView[0] &&
        lastView[1] === newView[1] &&
        lastView[2] === newView[2]
      ) {
        return;
      }
      this.lastView = newView;
      krpano1.call(`lookat(${lastView.join(',')})`);
      // console.log('第二个视图发生改变');
    },
    onmousedown2() {
      this.currentActive = 2;
    },
  },
};

function initPano({ xml, target = 'pano' }, hooks) {
  return new Promise((resolve) => {
    // eslint-disable-next-line no-undef
    embedpano({
      bgcolor: '#f3f3f3',
      xml,
      target,
      html5: 'only',
      passQueryParameters: true,
      onready(krpano) {
        krpano.hooks = hooks;
        hooks.ready(krpano);
        resolve();
      },
    });
  });
}
</script>

<style lang="less" scoped>
.compare-pano {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.pano-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.pano {
  height: 50%;
  position: relative;
}
.page-title {
  width: 750px;
  height: 92px;
  line-height: 92px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.36) 51%, rgba(0, 0, 0, 0) 100%);
  text-align: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99;
  &.landscape {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
  }
}
</style>